<section class="multi-checkbox-container">
	<section *ngIf="view">
		<div class="multi-checkbox-item" *ngFor="let item of myChosenList">
			{{item}}
		</div>
	</section>
	<section *ngIf="!view">
		<div class="empty-list" *ngIf="lookupSectionList == null">
			<span *ngIf="listSource == 'mortgages'">You have no mortgages in your plan. You can add one to your Debts later on and then connect it to this property.</span>
			<span *ngIf="listSource == 'property'">You have no property in your plan. You can add one to your Assets later on and then connect it to this insurance.</span>
			<span *ngIf="listSource == 'insurance'">You have no insurance in your plan. You can add one to your Daily Life later on and then connect it to this property.</span>
			<span *ngIf="listSource == 'utilities'">You have no utilities in your plan. You can add one to your Daily Life later on and then connect it to this property.</span>
		</div>
		<div *ngFor="let row of lookupSectionList">
			<label class="check-label">
				<input type="checkbox" class="form-check-input" name="{{row['Id']}}" value="{{row['Id']}}"
					   [checked]="row['checked']" (change)="onChange(row.Id,$event)"
				>
				<span [ngClass]="{removeMobilePhoneClass: fieldId == 'propertyUtilities' && row['utilityType'] == 'Mobile phone',
								  rHgS5orgPvsuzJ7shn8vw28y1XaePY4uDP: fieldId == 'propertyInsurances' && (row['insuranceType'] != 'Home' && row['insuranceType'] != 'Contents' 
																										&& row['insuranceType'] != 'Buildings' && row['insuranceType'] != 'Other')}" class="item-name">{{row['itemName']}}</span>
				<span [ngClass]="{removeMobilePhoneClass: fieldId == 'propertyUtilities' && row['utilityType'] == 'Mobile phone',
								  rHgS5orgPvsuzJ7shn8vw28y1XaePY4uDP: fieldId == 'propertyInsurances' && (row['insuranceType'] != 'Home' && row['insuranceType'] != 'Contents' 
																										&& row['insuranceType'] != 'Buildings' && row['insuranceType'] != 'Other')}" class="checkmark"></span>
			</label>
		</div>
		<div class="form-group">
			<div class="multicheckbox-container" *ngFor="let item of arrayOptionsList">
				<label class="check-label" for="{{item}}">{{item}}
					<input type="checkbox" class="form-check-input" id="{{item}}" name="{{item}}" [checked]="chosen">
					<span class="checkmark"></span>
				</label>
			</div>
		</div>
	</section>
</section>


